import React, { createContext } from 'react'
import usePageAlert from '../hooks/usePageAlert'

export const PageAlertContext = createContext({
  isPageAlertHidden: true,
  setPageAlert: () => {},
})

const PageAlertContextProvider = props => {
  const [isPageAlertHidden, setPageAlert] = usePageAlert()

  return (
    <PageAlertContext.Provider
      value={{
        isPageAlertHidden,
        setPageAlert,
      }}
    >
      {props.children}
    </PageAlertContext.Provider>
  )
}
export default PageAlertContextProvider
